export default "__VITE_ASSET__D4epxY69__"